<!-- eslint-disable max-lines -->
<template>
  <div :class="['widget', { 'border-error': error }]">
    <v-container>
      <v-layout align-center justify-space-between class="mb-3">
        <span class="subheading">
          Singlely covered devices [Disabled]
          <span v-if="!loading">
            since {{ backend.since | formatCal }}
            <span v-if="more">(10,000 msgs)</span>
            <span v-else>(1,000 msgs)</span>
          </span>
        </span>
        <v-btn
          :disabled="loading || moreLoading || more"
          class="ma-0"
          color="grey"
          outline
          small
          @click="getMore"
        >
          <v-progress-circular v-if="moreLoading" size="15" indeterminate />
          <span v-else>10,000 msgs</span>
        </v-btn>
      </v-layout>

      <template v-if="loading">
        <v-layout align-center justify-center fill-height>
          <v-progress-circular size="50" indeterminate />
        </v-layout>
      </template>

      <template v-else>
        <v-expansion-panel v-model="expand0" style="box-shadow: none">
          <v-expansion-panel-content
            v-for="group in Object.keys(backend.paths)"
            :key="group"
            style="background-color: initial"
          >
            <div slot="header" class="body-2">
              <v-layout align-center>
                <v-flex
                  v-for="parent in backend.paths[group]"
                  :key="parent"
                  shrink
                >
                  <v-layout align-center>
                    <span>{{ backend.names[parent] }}</span>
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-layout>
                </v-flex>
                <span>{{ backend.names[group] }}</span>
              </v-layout>
            </div>
            <v-container style="padding-top: 0; padding-right: 0">
              <v-layout>
                <v-flex style="min-width: 10em" shrink>
                  <span>Contacts</span>
                </v-flex>
                <v-flex shrink>
                  <table style="table-layout: fixed; width: 100%">
                    <tr>
                      <td class="grey--text">First name</td>
                      <td class="grey--text">Last name</td>
                      <td colspan="2" class="grey--text">Email</td>
                    </tr>
                    <tr
                      v-for="contact in backend.paths[group].length === 0
                        ? backend.contacts[group]
                        : backend.contacts[backend.paths[group][0]]"
                      :key="contact.email"
                    >
                      <td>{{ contact.firstName }}</td>
                      <td>{{ contact.lastName }}</td>
                      <td colspan="2">
                        {{ contact.email }}
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
              <v-layout class="mt-3">
                <v-flex style="min-width: 10em" shrink>
                  <span>Details</span>
                </v-flex>
                <v-flex shrink>
                  <table style="table-layout: fixed; width: 100%">
                    <tr>
                      <td class="grey--text">Device</td>
                      <td class="grey--text">Last message</td>
                      <td class="grey--text">Messages count</td>
                      <td />
                    </tr>
                    <tr v-for="device in backend.devices[group]" :key="device">
                      <td>{{ device }}</td>
                      <td>
                        <v-tooltip left>
                          <span slot="activator">
                            {{ backend.messages.last[device] | formatFn }}
                          </span>
                          <span>
                            {{ backend.messages.last[device] | formatLLL }}
                          </span>
                        </v-tooltip>
                      </td>
                      <td class="text-xs-right">
                        {{ backend.messages.counts[device] }}
                      </td>
                      <td />
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </template>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "contacts",
  data() {
    return {
      backend: {
        bs: "",
        contacts: {},
        devices: {},
        messages: {
          counts: {},
          last: {},
        },
        names: {},
        paths: {},
        since: "2018-01-01T00:00:00.000Z",
      },
      contacts: [],
      error: false,
      expand0: -1,
      expand1: -1,
      loading: false,
      more: false,
      moreLoading: false,
    };
  },
  created() {
    // this.loading = true;
    // this.$http.
    //   get(`/api/sites/${this.$route.params.id}/customers?initial=10`).
    //   then((r) => {
    //     Object.assign(this.backend, r.data);
    //   }).
    //   catch(() => this.error = true).
    //   finally(() => this.loading = false);
  },
  methods: {
    getMore() {
      // this.moreLoading = true;
      // this.$http.
      //   get(`/api/sites/${this.$route.params.id}/customers?initial=100`).
      //   then((r) => {
      //     Object.assign(this.backend, r.data);
      //     this.more = true;
      //   }).
      //   catch(() => this.error = true).
      // finally(() => this.moreLoading = false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Site/Customers.vue